export default __webpack_public_path__ + "static/media/hht2_ep01_timeline_q04_a.18b6f3cf.png";